<template>
  <div>
    <!-- 2021/12/14 该页面废弃 因为在组件中使用Sortable拖拽有时会不生效 YLL -->
    <!--  拖拽表格-->
    <!--  <div style="">
    <table class="dataTabble">
      <thead>
      <tr>
        <th width="">{{ $t('common.index') }}</th>
        <th width="">{{ $t('common.name') }}</th>
        <th width="">{{ $t('common.jigou') }}</th>
        <th width="">{{ $t('common.bindingEmail') }}</th>
        <th width="">{{ $t('common.bindingPhone') }}</th>
        <th width="">{{ $t('common.handle') }}</th>
      </tr>
      </thead>
      <tbody v-model="tablelist" element="tbody" :move="getdata" @update="datadragEnd">
        <tr v-for="(item,index) in tablelist" :key="index">
          <td>{{index+1}}</td>
          <td>{{item.userName}}</td>
          <td>{{item.orgName}}</td>
          <td>{{item.email}}</td>
          <td>{{item.phone}}</td>
          <td>
            <div class="tabopa">
              <el-button
                size="mini"
                icon="el-icon-delete"
                type="danger"
                @click="handleDelete(index,item)">{{ $t('common.delete') }}</el-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div> -->
    <el-table
      :data="tablelist"
      style="width: 100%"
      max-height="350"
      row-key="userId"
      :id="'elTableUser' + type"
      :empty-text="$t('common.noData')"
    >
      <el-table-column
        type="index"
        :label="$t('common.index')"
        width="50"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="userName"
        :label="$t('common.name')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orgName"
        :label="$t('common.jigou')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="email"
        :label="$t('common.bindingEmail')"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="phone"
        :label="$t('common.bindingPhone')"
        align="center"
      >
      </el-table-column>
      <el-table-column :label="$t('common.handle')" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            icon="el-icon-delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >{{ $t("common.delete") }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!--  删除确认弹框-->
    <h-popup ref="delete" @confirm="confirmDelete">
      <template slot="title">{{ $t("common.tip") }}</template>
      <template slot="tip"> {{ $t("common.isConfirmdelete") }} </template>
    </h-popup>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import hPopup from "@/components/common/hPopup";
import draggable from "vuedraggable";
export default {
  props: ["list", "type"],
  data() {
    return {
      index: 0,
      // paramSingleDocCode:'',//文章id
      // currentId:'',//当前删除的id
      // dialogVisible: false,
      tablelist: [
        {
          userId: "1234",
          userName: "王晓丽",
          orgCode: "0187103",
          orgName: "机构1",
          email: "211212@164.com",
          phone: "183929292121",
        },
        {
          userId: "12341",
          userName: "王晓丽1",
          orgCode: "0187103",
          orgName: "机构1",
          email: "211212@164.com",
          phone: "183929292121",
        },
      ],
    };
  },
  mounted() {
    this.tablelist = JSON.parse(JSON.stringify(this.list));
    setTimeout(() => {
      this.rowDropUser();
      this.rowDropContact();
    }, 500);
  },
  components: {
    draggable,
    hPopup,
    Sortable,
  },
  methods: {
    //行拖拽
    rowDropUser() {
      const tbody = document.querySelector(
        "#elTableUserauthor .el-table__body-wrapper tbody"
      );
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          _this.handelDraggleC(newIndex, oldIndex);
        },
      });
    },
    //行拖拽
    rowDropContact() {
      const tbody = document.querySelector(
        "#elTableUsercontact .el-table__body-wrapper tbody"
      );
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          _this.handelDraggleC(newIndex, oldIndex);
        },
      });
    },
    handelDraggleC(newIndex, oldIndex) {
      debugger
      this.$emit("handelDraggle", newIndex, oldIndex, this.type);
    },
    //列表删除
    handleDelete(row) {
      this.$emit("confirmDelete", row, this.type);
    },
    confirmDelete() {
      this.$refs["delete"].closeDialog();
      this.$message.success("删除成功");
      // this.$emit('requestUserList')

      // const data = {
      //   answerCode: this.currentId,
      //   questionCode: this.,
      // };
      // this.$api.delete(data).then((res) => {
      //   if (res.success == true) {
      //     this.$message.success("删除答案成功");
      //     this.$refs["del-answer"].closeDialog();
      //     this.getAnswer();
      //   }
      // });
    },
    //拖拽
    getdata(evt) {
      console.log(evt.draggedContext.element.id);
    },
    datadragEnd(evt) {
      console.log("拖动前的索引 :" + evt.oldIndex);
      console.log("拖动后的索引 :" + evt.newIndex);
      console.log(this.tablelist);
    },
  },
};
</script>

<style scoped lang="scss">
.dataTabble {
  width: 100%;
  thead {
    width: 100%;
    tr {
      height: 60px;
      font-size: 14px;
      border-bottom: 1px solid #e4e9ef;
      color: #979797;
    }
    th {
      padding: 0 10px;
    }
  }
  tbody {
    tr {
      height: 60px;
      font-size: 16px;
      border-bottom: 1px solid #e4e9ef;
      transition: background-color 0.2s;
    }
    tr:hover {
      background: #f5f7fa;
    }
    td {
      padding: 0 10px;
      font-size: 14px;
    }
  }
}
</style>
